import React, { Component } from 'react';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import './styles.scss';

class GeAccountLoader extends Component {
  render() {
    return (
      <div className="ge-account-details-wrapper">
        <SkeletonTheme color="#848484" highlightColor="#373737">
          <div className="account-details">
            <div className="account-logo">
              <Skeleton circle={true} height={100} width={100} />
            </div>
            <div className="details-wrapper">
              <div className="details-info">
                <Skeleton width={150} height={16} style={{ marginLeft: 8 }} />
              </div>
              <div className="details-info">
                <Skeleton width={150} height={16} style={{ marginLeft: 8 }} />
              </div>
            </div>
          </div>
        </SkeletonTheme>
      </div>
    );
  }
}

export default GeAccountLoader;